import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { EditWidgetDrawerModal } from "@src/components/organisms/modals/edit-widget-drawer-modal/edit-widget-drawer-modal";

export const EditWidgetDrawer = () => {
  const editWidgetDrawerModal = useSelector(
    (state: RootState) =>
      state.yourSlice.modals.editWidgetDrawerModal.showModal,
  );

  return <>{editWidgetDrawerModal && <EditWidgetDrawerModal />}</>;
};
